export default __webpack_public_path__ + "static/media/payment-method.2c3b556c.svg";